// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reply-field{margin-left:50px;margin-top:20px;position:relative}.reply-field>.controls{display:flex;margin-left:-10px;margin-right:-10px;margin-top:20px}.reply-field>.controls>*{margin-left:10px;margin-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
